import { CrossIcon } from '../../../../assets/images/icons';
import styles from './Buttons.module.scss';

export const DeleteButton = ({ handler }: { handler: () => void }) => (
  <div className={styles.btn_delete} onClick={handler}>
    <CrossIcon />
  </div>
);
